var exports = {
  "k": "checksButton__jvGzeb",
  "A": "checksCountText__jq8uhR",
};

module.exports = exports;
